import { createRouter, createWebHistory } from 'vue-router';
import App from './App.vue'

const routes = [
    {
        path: '/',
        name: '',
        alias: ['/dev'],
        redirect: '/home',
        component: App
    },
    {
        path: '/home',
        name: 'Home',
        component: () => import('./views/HomeView.vue')
    },
    {
        path: '/design',
        name: 'Design',
        component: () => import('./views/DesignView.vue')
    },
    {
        path: '/engraving',
        name: 'Engraving',
        component: () => import('./views/EngravingView.vue')
    },
    {
        path: '/marking',
        name: 'Marking',
        component: () => import('./views/MarkingView.vue')
    },
    {
        path: '/printing',
        alias: ['/uvprinting'],
        name: 'Printing',
        component: () => import('./views/PrintingView.vue')
    },
    {
        path: '/dtf',
        alias: ['/uvdtf'],
        name: 'UV DTF',
        component: () => import('./views/UvDtfView.vue')
    },
    {
        path: '/sublimation',
        name: 'Sublimation',
        component: () => import('./views/SublimationView.vue')
    },
    {
        path: '/calendar',
        name: 'Calendar',
        component: () => import('./views/CalendarView.vue')
    },
    {
        path: '/login',
        name: 'Login',
        component: () => import('./views/LoginView.vue')
    },
    {
        path: '/about',
        name: 'About Us',
        component: () => import('./views/AboutUsView.vue')
    },
    {
        path: '/fundraising',
        name: 'Fundraising',
        component: () => import('./views/FundraisingView.vue')
    },
    {
        path: '/partner',
        name: 'Partner',
        component: () => import('./views/PartnerView.vue')
    },
    {
        path: '/store',
        name: 'Online Store',
        component: () => import('./views/StoreView.vue')
    },
    {
        path: '/contact',
        name: 'Contact',
        component: () => import('./views/ContactView.vue')
    },
    {
        path: '/support',
        name: 'Support',
        component: () => import('./views/SupportView.vue')
    },
    {
        path: '/privacy',
        name: 'Privacy',
        component: () => import('./views/PrivacyView.vue')
    },
    {
        path: '/tos',
        name: 'ToS',
        component: () => import('./views/TOSView.vue')
    },
    {
        path: '/:pathMatch(.*)*',
        name: 'NotFound',
        component: () => import('./views/NotFoundView.vue')
    },
];

const cName = 'Brookside Laser and Printing';
// const cName = 'Brookside Laser, LLC';
// import { getCurrentInstance } from 'vue';
// const app = getCurrentInstance();
// const cName = app.appContext.config.globalProperties.$kCompanyName;

const router = createRouter({
    history: createWebHistory(),
    routes,
});

router.beforeEach((to, from, next) => {
    document.title = cName + ': ' + to.name;
    next();
});


export default router;
